import { NewReturnHub } from '@dhl/mdp-api'
import { convertToAddressDto } from '~/common/components/addresses'
import type { ReturnHubData } from '~/modules/returnhubsccc/model'

export const convertToNewReturnHub = (returnhubData: ReturnHubData): NewReturnHub => ({
  ...returnhubData,
  address: convertToAddressDto(returnhubData.address),
})
